import { gql } from '@graphql/__generated__';
import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const ENQUIRY_RESPONSE_ANCHORS = {
  template: 'enquiry-response-template',
  autoSend: 'enquiry-response-auto-send',
} as const;

const GET_TOUR_LISTING = gql(/* GraphQL */ `
  query GetEnquiryResponseTourListing($userId: uuid!) {
    active: lots(
      where: {
        broker_id: { _eq: $userId }
        status: {
          _in: [available, available_coming_soon, available_off_market]
        }
      }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
    any: lots(
      where: { broker_id: { _eq: $userId } }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
    visible: lots(
      where: {
        status: {
          _in: [available, available_coming_soon, available_off_market]
        }
      }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
  }
`);

// The Enquiry response email of a listing's Marketing tab
// (`EnquiryResponseEmailForm.tsx`). Played from "Show me" on
// `content/releases/enquiry-auto-response`.
export const enquiryResponseTour: TourModule = {
  steps: t => [
    {
      anchor: ENQUIRY_RESPONSE_ANCHORS.template,
      title: t('A ready-made reply'),
      body: t(
        'The subject and message are filled in with the listing and an Open brochure button. Adjust them if needed, then Save.',
      ),
      placement: 'left-start',
    },
    {
      anchor: ENQUIRY_RESPONSE_ANCHORS.autoSend,
      title: t('Send email automatically'),
      body: t(
        'Switch it on and every enquiry gets this reply within minutes. You see when the person opens the brochure.',
      ),
      placement: 'bottom-start',
    },
  ],
  // The user's latest active listing, else their latest listing, else the
  // latest active listing they can see.
  resolvePath: async ({ client, userId }) => {
    const { data } = await client.query({
      query: GET_TOUR_LISTING,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    const lotId =
      data?.active[0]?.id ?? data?.any[0]?.id ?? data?.visible[0]?.id;
    return lotId == null
      ? null
      : `/listings/${lotId}/marketing/enquiry-response`;
  },
};
